import script from "./AirPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AirPage.vue?vue&type=script&setup=true&lang=js"

import "./AirPage.vue?vue&type=style&index=0&id=1b6b4132&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b6b4132"]])

export default __exports__